/**
 * Conversation limit ("modo cola") — where "Liberar conversación" is shown.
 *
 * The button's home is the client-data panel, but that panel is hidden at
 * ≤1024 px (`CRMArea` in pages/chat/chatPage.style.js and `.BoardMain__crm`
 * in views/Board/styles.css). Below that width the same component is shown
 * in the chat header instead, so a seat can be released on tablet and phone.
 * Pure module: the CSS media queries are built from this one constant.
 */

/** Widest viewport at which the client-data panel is hidden. */
export const CLIENT_PANEL_HIDDEN_MAX_WIDTH = 1024;

export const RELEASE_PLACEMENT = Object.freeze({ PANEL: 'panel', HEADER: 'header' });

/** Anything that is not the header placement is the panel one. */
export const normalizeReleasePlacement = (placement) =>
  placement === RELEASE_PLACEMENT.HEADER ? RELEASE_PLACEMENT.HEADER : RELEASE_PLACEMENT.PANEL;

/** Which placement is visible at a viewport width; mirrors the CSS below. */
export const releasePlacementAt = (viewportWidth) =>
  Number.isFinite(viewportWidth) && viewportWidth >= 0 && viewportWidth <= CLIENT_PANEL_HIDDEN_MAX_WIDTH
    ? RELEASE_PLACEMENT.HEADER
    : RELEASE_PLACEMENT.PANEL;

/** Media query that matches while the client-data panel is visible. */
export const CLIENT_PANEL_VISIBLE_MEDIA = `@media (min-width: ${CLIENT_PANEL_HIDDEN_MAX_WIDTH + 1}px)`;
